import { render, staticRenderFns } from "./MolliePaymentMethods.vue?vue&type=template&id=16d59c40&scoped=true"
import script from "./MolliePaymentMethods.vue?vue&type=script&lang=js"
export * from "./MolliePaymentMethods.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16d59c40",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('16d59c40')) {
      api.createRecord('16d59c40', component.options)
    } else {
      api.reload('16d59c40', component.options)
    }
    module.hot.accept("./MolliePaymentMethods.vue?vue&type=template&id=16d59c40&scoped=true", function () {
      api.rerender('16d59c40', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/assets/js/Components/MolliePaymentMethods.vue"
export default component.exports